import { useGetClients } from "@/hooks/clients";
import { useGetReservationClients } from "@/hooks/reservation-clients";
import { useMemo } from "react";

export function useGetReservationClientsWithNames(reservationId: string) {
  const { data: reservationClients, isLoading: reservationClientsLoading } =
    useGetReservationClients(reservationId);
  const { data: clients, isLoading: clientsLoading } = useGetClients();
  const isLoading = useMemo(
    () => clientsLoading || reservationClientsLoading,
    [clientsLoading, reservationClientsLoading],
  );
  const data = useMemo(() => {
    if (!reservationClients || !clients) return undefined;
    return reservationClients.map((rc) => ({
      id: rc.id,
      name: clients.find((c) => c.id === rc.clientId.toString())?.name,
    }));
  }, [clients, reservationClients]);

  return useMemo(() => ({ data, isLoading }), [data, isLoading]);
}

export function useGetReservationClientWithName(
  reservationId: string,
  reservationClientId: string,
) {
  const { data, isLoading } = useGetReservationClientsWithNames(reservationId);
  return useMemo(
    () => ({
      isLoading,
      data: data?.find((c) => c.id === reservationClientId),
    }),
    [data, isLoading, reservationClientId],
  );
}
